export default __webpack_public_path__ + "static/media/arw-04113.4a5d350b.jpg";